import React, { useEffect, useState, ChangeEvent, useRef } from "react";
import { CheckIcon, Squares2X2Icon } from "@heroicons/react/24/outline";
import PhoneInput from "react-phone-input-2";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import { Checkbox } from "@headlessui/react";
import toast from "react-hot-toast";
import { formatDateTime, useData } from "data/data-provider";
import { getInvoice } from "api/Invoice/invoice";
import { Booking, uploadInsuranceDocuments } from "api/booking/booking";
import { globalJson } from "global/global_json";
import Input from "shared/Input/Input";
import { getBonzahProducts } from "api/bonzah/bonzah";
import { AddCustomer } from "api/customer/customer";
import Badge from "shared/Badge/Badge";
import moment from "moment";
import { LocationListingModal } from "models/LocationModal";
import { getLocationData } from "api/locations/locations";
import DropOffBranchLocationInput from "designs/Common/DropOffBranchLocationInput";
import LocationBranchInput from "designs/Common/LocationBranchInput";
import RentalCarDatesRangeInput from "../(car-search-form)/RentalCarDatesRangeInput";
import RentalCarTimesRangeInput from "../(car-search-form)/RentalCarTimesRangeInput";
import useNavigationGuard from "utils/useNavigationGuard";
import NcModal from "../NcModal/NcModal";
import { Slide } from "react-slideshow-image";
import { pick, set } from "lodash";
import DateRangeSelection from "../(car-search-form)/dateRangeSelection";
import LongTermRentalUI from "../ListingDetailPage/listing-car-detail/LongTermRentalUI";
import Invoice from "../(car-search-form)/invoice";
import VehicleDetailsSection from "../VehicleDescription/VehicleDescriptionSection";
import { formatPrice } from "utils/convertNumbThousand";
import { encodeBase64 } from "@progress/kendo-file-saver";
import { getRentalAgreementContent } from "api/rental-agreement/rental-agreement";
import BackRouteButton from "shared/BackRouteButton/BackRouteButton";

export default function CarListingCarDetailPage() {
  const navigate = useNavigate();
  const initialBonzahFetched = useRef(false);
  const {
    selectedCar,
    user,
    startDate,
    startHours,
    startMinutes,
    startPeriod,
    endDate,
    endHours,
    endMinutes,
    pickupLocation,
    setInvoice,
    selectedExtras,
    setSelectedExtras,
    bonzahProducts,
    setBookingdetails,
    setBonzahProducts,
    setSelectedBonzahProducts,
    selectedBonzahProducts,
    setSelectedBonzahAddOns,
    selectedBonzahAddOns,
    invoice,
    setSameDropoffLocation,
    dropOffLocation,
    searchedPickupLoction,
    searchedDropoffLocation,
    sameDropoffLocation,
    dropoffLocationType,
    setDropoffLocationType,
    setDropoffLocation,
    endPeriod,
    firstName,
    setFirstName,
    lastName,
    unavailable,
    setLastName,
    email,
    setEmail,
    phone,
    setPhone,
    setPickupLocation,
    setStartDate,
    setEndDate,
    startTime,
    endTime,
    ourCompany,
    is_long_term_rental,
    long_term_rental_nature,
    long_term_rental_duration,
    selectedMonth,
    selectedWeeks,
    setSelectedWeeks,
    setSelectedMonth,
    ourLocation: providerLocations,
  } = useData();

  let [bonzahProductsLoading, setBonzahProductsLoading] = useState(false);
  const [isDropOffVisible, setIsDropOffVisible] = useState(false);
  const [selectedBonzahType, setSelectedBonzahType] = useState<any>([]);
  const selectedBonzahTypeRef = useRef<any>([]);
  const bonzahProductsRef = useRef<any>(null);

  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  const [loading, setLoading] = useState<boolean>(false);
  const [ourLocation, setOurLocation] = useState<LocationListingModal[]>([]);
  const [isMoreThan30Days, setIsMoreThan30Days] = useState(false);
  const [isReadMore, setIsReadMore] = useState(true);
  const [selectedBonzah, setSelectedBonzah] = useState();
  const [loadingLater, setLoadingLater] = useState(false);
  const [showImgGallery, setShowImgGallery] = useState(false);
  const [isFormDirty, setIsFormDirty] = useState(false);
  const pendingNavigationRef = useRef(false);
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [isGridOpen, setIsGridOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [proofOfInsuranceFiles, setProofOfInsuranceFiles] = useState<{ file: File; url: string }[]>([]);
  const fileInputRef = useRef<HTMLInputElement>(null);
  const { isDialogOpen, isLeaving, confirmNavigation, cancelNavigation } =
    useNavigationGuard({
      when: isFormDirty,
      onConfirm: () => {
        setIsFormDirty(false);
        const activeLocations = providerLocations.filter((loc) => loc.active !== false);
        if (activeLocations.length === 1) {
          setPickupLocation(activeLocations[0]);
          setDropoffLocation(activeLocations[0]);
        } else {
          setPickupLocation(null);
          setDropoffLocation(null);
        }
        setStartDate(null);
        setEndDate(null);
        setSameDropoffLocation(true);
        setInvoice([]);
        setDropoffLocationType(true);
        setFirstName("");
        setLastName("");
        setEmail("");
        setPhone("");
        setSelectedWeeks([]);
        setSelectedMonth(0);
      },
    });

  useEffect(() => {
    const dirty = Boolean(
      firstName ||
      lastName ||
      email ||
      phone ||
      pickupLocation ||
      dropOffLocation ||
      startDate ||
      endDate,
    );
    setIsFormDirty(dirty);
  }, [
    firstName,
    lastName,
    email,
    phone,
    pickupLocation,
    dropOffLocation,
    startDate,
    endDate,
  ]);

  const toggleReadMore = () => {
    setIsReadMore(!isReadMore);
  };

  const validateForm = () => {
    const newErrors: { [key: string]: string } = {};

    if (!firstName?.trim()) {
      newErrors.firstName = "First Name is required";
    }
    if (!lastName?.trim()) {
      newErrors.lastName = "Last Name is required";
    }
    if (!email?.trim()) {
      newErrors.email = "Email is required";
    } else if (
      !/^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/.test(email.trim())
    ) {
      newErrors.email = "Please enter a valid email address";
    }
    if (!phone?.trim()) {
      newErrors.phone = "Phone number is required";
    } else if (phone.replace(/\D/g, "").length < 10) {
      newErrors.phone = "Please enter a valid phone number";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const clearError = (field: string) => {
    setErrors((prevErrors) => {
      const updatedErrors = { ...prevErrors };
      delete updatedErrors[field];
      return updatedErrors;
    });
  };

  useEffect(() => {
    const activeLocations = providerLocations.filter((loc) => loc.active !== false);
    if (activeLocations.length !== 1) {
      setPickupLocation(null);
      setDropoffLocation(null);
    }
    setStartDate(null);
    setEndDate(null);
    setSameDropoffLocation(true);
    setInvoice([]);
    setDropoffLocationType(true);
    setSelectedWeeks([]);
  }, []);

  useEffect(() => {
    const activeLocations = ourLocation.filter((loc) => loc.active !== false);
    if (activeLocations.length === 1) {
      setPickupLocation(activeLocations[0]);
      setDropoffLocation(activeLocations[0]);
    }
  }, [ourLocation, setPickupLocation, setDropoffLocation]);

  useEffect(() => {
    selectedBonzahTypeRef.current = selectedBonzahType;
  }, [selectedBonzahType]);

  useEffect(() => {
    bonzahProductsRef.current = bonzahProducts;
  }, [bonzahProducts]);

  useEffect(() => {
    if (!startDate || !endDate) {
      setIsMoreThan30Days(false);
      return;
    }
    if (startDate && endDate) {
      const start = moment(`${moment(startDate).format("YYYY-MM-DD")} ${startTime}`, "YYYY-MM-DD HH:mm");
      const end = moment(`${moment(endDate).format("YYYY-MM-DD")} ${endTime}`, "YYYY-MM-DD HH:mm");
      const daysDifference = end.diff(start, "days", true);
      const currentBonzahType = selectedBonzahTypeRef.current;
      const currentBonzahProducts = bonzahProductsRef.current;

      if (daysDifference > 30 && (!is_long_term_rental || long_term_rental_nature === "daily")) {
        setIsMoreThan30Days(true);
        // Always clear addons when exceeding 30 days — Bonzah addons are not available
        setSelectedBonzahAddOns(new Set());
        const selectedProduct = currentBonzahProducts?.insurance_options?.find(
          (product: any) =>
            JSON.stringify(product.value) ===
            JSON.stringify(currentBonzahType),
        );
        if (selectedProduct && selectedProduct.insurance_by_bonzah === true) {
          toast("Bonzah Insurance is not available for more than 30 days", {
            id: "bonzah-30-days-warning",
            style: {
              background: "#fff3cd",
              color: "#856404",
            },
          });
          const canopyProduct = currentBonzahProducts?.insurance_options?.find(
            (product: any) => product.canopy === true,
          );
          if (canopyProduct) {
            setSelectedBonzahType(canopyProduct.value);
            setSelectedBonzahProducts(new Set([canopyProduct.value]));
          } else {
            setSelectedBonzahType([]);
            setSelectedBonzahProducts(new Set());
          }
        }
      } else {
        setIsMoreThan30Days(false);
        if (!currentBonzahType || currentBonzahType?.length === 0) {
          const canopyProduct = currentBonzahProducts?.insurance_options?.find(
            (product: any) => product.canopy === true,
          );
          if (canopyProduct) {
            setSelectedBonzahType(canopyProduct.value);
            setSelectedBonzahProducts(new Set([canopyProduct.value]));
          }
        }
      }
    }
  }, [startDate, endDate, startTime, endTime, is_long_term_rental, long_term_rental_nature]);

  useEffect(() => {
    const activeLocations = providerLocations.filter((loc) => loc.active !== false);
    if (activeLocations.length !== 1) {
      setPickupLocation(null);
      setDropoffLocation(null);
    }
    setStartDate(null);
    setEndDate(null);
  }, []);

  const toggleDropOffLocation = () => {
    setIsDropOffVisible((prevState) => !prevState);
  };

  const handleDropOffLocationClick = () => {
    toggleDropOffLocation();
    setDropoffLocationType(false);
    setSameDropoffLocation(false);
  };
  const handlePickupLocationClick = () => {
    toggleDropOffLocation();
    setDropoffLocationType(true);
    setSameDropoffLocation(true);
    setDropoffLocation(null);
  };

  const closeModal = () => {
    setIsOpenModal(false);
  };

  const closeGridModal = () => setIsGridOpen(false);

  const isDdropOffdifferent = dropoffLocationType === false;

  const fetchBonzahProducts = async (selectedType?: string) => {
    if (!selectedCar) {
      return;
    }
    setBonzahProductsLoading(true);
    const payload = {
      company_id: globalJson.company_id,
      selected_type: selectedType,
      fleet: selectedCar?.id,
      pickup_location: pickupLocation?.id,
    };

    const { data } = await getBonzahProducts(payload);
    if (data) {
      setBonzahProducts(data);
      const _start = startDate && startTime
        ? moment(`${moment(startDate).format("YYYY-MM-DD")} ${startTime}`, "YYYY-MM-DD HH:mm")
        : null;
      const _end = endDate && endTime
        ? moment(`${moment(endDate).format("YYYY-MM-DD")} ${endTime}`, "YYYY-MM-DD HH:mm")
        : null;
      const isOver30 = _start && _end
        ? _end.diff(_start, "days", true) > 30 && (!is_long_term_rental || long_term_rental_nature === "daily")
        : false;

      const validAddOns = isOver30
        ? new Set<any>()
        : new Set(
          Array.from(selectedBonzahAddOns).filter((addon: any) =>
            data?.addons?.some((item: any) => item.value[0] === addon),
          ),
        );
      setSelectedBonzahAddOns(validAddOns);
      if (data?.insurance_options?.length > 0) {
        if (selectedBonzahType?.length === 0) {
          setSelectedBonzahProducts(new Set([data.insurance_options[0].value]));
          setSelectedBonzahType(data.insurance_options[0].value);
        }
      }
    }
    setBonzahProductsLoading(false);
  };

  const hasCanopyOption = () => {
    return (
      Array.isArray(bonzahProducts?.insurance_options) &&
      bonzahProducts.insurance_options.some(
        (product: any) => product.canopy === true,
      )
    );
  };

  const handleBonzahProductSelection = (
    productType: string,
    value: any,
    canopy: boolean,
  ) => {
    const hasCanopy = hasCanopyOption();

    if (JSON.stringify(selectedBonzahType) === JSON.stringify(value)) {
      if (!hasCanopy) {
        setSelectedBonzahType([]);
        setSelectedBonzahProducts(new Set());
        fetchBonzahProducts();
      }
    } else {
      setSelectedBonzahType(value);
      setSelectedBonzahProducts(new Set([value]));
      fetchBonzahProducts(productType);
    }
  };

  useEffect(() => {
    if (!initialBonzahFetched.current) {
      if (!selectedCar) {
        return;
      }
      const fetchInitialBonzah = async () => {
        const { data } = await getBonzahProducts({
          company_id: globalJson.company_id,
          fleet: selectedCar?.id,
        });

        if (data) {
          setBonzahProducts(data);
          if (data.insurance_options?.length > 0) {
            setSelectedBonzahProducts(
              new Set([data.insurance_options[0].value]),
            );
            setSelectedBonzahType(data.insurance_options[0].value);
            fetchBonzahProducts(data.insurance_options[0].title.toLowerCase());
            setSelectedBonzah(data.insurance_options[0].title.toLowerCase());
          }
        }
      };
      fetchInitialBonzah();
      initialBonzahFetched.current = true;
    } else {
      if (selectedBonzahType?.length > 0) {
        fetchBonzahProducts(selectedBonzah);
      } else {
        fetchBonzahProducts();
      }
    }
  }, [startDate, endDate, selectedCar, pickupLocation]);

  const toggleAddonSelection = (addonType: string) => {
    setSelectedBonzahAddOns((prevSelected) => {
      const updatedSet = new Set(prevSelected);
      if (updatedSet.has(addonType)) {
        updatedSet.delete(addonType);
      } else {
        updatedSet.add(addonType);
      }
      return updatedSet;
    });
  };

  const fetchInvoice = async () => {
    if (isDdropOffdifferent && dropOffLocation === null) {
      return;
    } else {
      const selectedAddons = Array.from(selectedBonzahAddOns);
      const addonsValues = selectedAddons
        .map((item) => {
          const addon = bonzahProducts.addons.find(
            (addon: any) => addon.value[0] === item,
          );
          return addon ? addon.value : [];
        })
        .flat();

      let payload: any = {
        customer: user?.id,
        fleet: selectedCar?.id,
        pick_up_time: formatDateTime(startDate, startTime),
        drop_off_time: formatDateTime(endDate, endTime),
        pick_up_location: pickupLocation?.id,
        drop_off_location:
          sameDropoffLocation === false
            ? dropOffLocation?.id
            : pickupLocation?.id,
        custom_pick_up_address: searchedPickupLoction,
        custom_drop_off_address:
          sameDropoffLocation === false
            ? searchedDropoffLocation
            : searchedPickupLoction,
        same_drop_off_address: sameDropoffLocation,
        extras: Array.from(selectedExtras),
        bonzah_insurance_options: [...selectedBonzahType, ...addonsValues],
      };

      if (
        ourCompany?.allow_long_term_rentals &&
        long_term_rental_nature !== "daily"
      ) {
        payload = {
          ...payload,
          is_long_term_rental: is_long_term_rental,
          long_term_rental_nature: long_term_rental_nature,
          long_term_rental_duration: long_term_rental_duration,
        };
      }

      const data = await getInvoice(payload);
      // setLongTermInvoice(data);
      setInvoice(data);
    }
  };

  useEffect(() => {
    fetchInvoice();
  }, [
    selectedExtras,
    selectedBonzahProducts,
    selectedBonzahAddOns,
    pickupLocation,
    startMinutes,
    startPeriod,
    startHours,
    endMinutes,
    endPeriod,
    endHours,
    endMinutes,
    endPeriod,
    startDate,
    endDate,
    dropOffLocation,
    sameDropoffLocation,
    searchedPickupLoction,
    searchedDropoffLocation,
  ]);

  useEffect(() => {
    setSameDropoffLocation(true);
    setSelectedExtras(new Set());
    setSelectedBonzahProducts(new Set());
    setSelectedBonzahAddOns(new Set());
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
    localStorage.removeItem("user");
  }, []);

  useEffect(() => {
    if (selectedCar) {
      callOurLocationAPI();
    }
  }, [selectedCar]);

  const handleBooking = async () => {
    if (pickupLocation === null) {
      toast.error("Please select pick-up location");
      return;
    }
    if (!sameDropoffLocation && dropOffLocation === null) {
      toast.error("Please select drop-off location");
      return;
    }
    if (startDate === null) {
      toast.error("Start date is not set");
      return;
    }

    if (endDate === null) {
      toast.error("End date is not set");
      return;
    }

    if (!validateForm()) {
      toast.error("Please fill in the details");
      return;
    }

    if (!startTime) {
      toast.error("Start time is not set");
      return;
    }

    if (!endTime) {
      toast.error("End time is not set");
      return;
    }

    if (!selectedBonzahType || selectedBonzahType.length === 0) {
      toast.error("Please select a trip insurance option");
      return;
    }

    const selectedInsuranceProduct = bonzahProducts?.insurance_options?.find(
      (p: any) => JSON.stringify(p.value) === JSON.stringify(selectedBonzahType),
    );
    const requiresProofOfInsurance =
      selectedInsuranceProduct &&
      selectedInsuranceProduct.upload_before_payment === true;
    if (requiresProofOfInsurance && proofOfInsuranceFiles.length === 0) {
      toast.error("Please upload your Proof of Insurance document");
      return;
    }

    setLoading(true);
    const selectedAddons = Array.from(selectedBonzahAddOns);
    const addonsValues = selectedAddons
      .map((item) => {
        const addon = bonzahProducts.addons.find(
          (addon: any) => addon.value[0] === item,
        );
        return addon ? addon.value : [];
      })
      .flat();

    const customerPayload = {
      first_name: firstName,
      last_name: lastName,
      email,
      phone_no: phone,
      company: globalJson.company_id,
    };

    try {
      const response = await AddCustomer(customerPayload);
      if (response.data.detail) {
        toast.error(response.data.detail);
        return;
      }

      if (response.data) {
        localStorage.setItem("access_token", response.data.access_token);
        localStorage.setItem("refresh_token", response.data.refresh_token);
        localStorage.setItem("user", JSON.stringify(response.data));

        const customerId = response.data.id;

        let payload: any = {
          customer: customerId,
          fleet: selectedCar?.id,
          pick_up_time: formatDateTime(startDate, startTime),
          drop_off_time: formatDateTime(endDate, endTime),
          pick_up_location: pickupLocation?.id,
          drop_off_location:
            sameDropoffLocation === false
              ? dropOffLocation?.id
              : pickupLocation?.id,
          custom_pick_up_address: searchedPickupLoction,
          custom_drop_off_address:
            sameDropoffLocation === false
              ? searchedDropoffLocation
              : searchedPickupLoction,
          same_drop_off: sameDropoffLocation,
          extras: Array.from(selectedExtras),
          bonzah_insurance_options: [...selectedBonzahType, ...addonsValues],
        };

        if (
          ourCompany?.allow_long_term_rentals &&
          long_term_rental_nature !== "daily"
        ) {
          payload = {
            ...payload,
            is_long_term_rental: is_long_term_rental,
            long_term_rental_nature: long_term_rental_nature,
            long_term_rental_duration: long_term_rental_duration,
          };
        }
        let finalBookingPayload: any = payload;
        const bookingResponse = await Booking(finalBookingPayload);
        setBookingdetails(bookingResponse);
        if (bookingResponse.error) {
          toast.error(bookingResponse.error);
          return;
        }
        if (requiresProofOfInsurance && proofOfInsuranceFiles.length > 0 && bookingResponse?.id) {
          for (const { file } of proofOfInsuranceFiles) {
            await uploadInsuranceDocuments(String(bookingResponse.id), file);
          }
          setProofOfInsuranceFiles([]);
        }
        navigate("/checkout");
      }
    } catch (err: any) {
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const handleBookingLater = async () => {
    if (pickupLocation === null) {
      toast.error("Please select pick-up location");
      return;
    }
    if (!sameDropoffLocation && dropOffLocation === null) {
      toast.error("Please select drop-off location");
      return;
    }
    if (startDate === null) {
      toast.error("Start date is not set");
      return;
    }

    if (endDate === null) {
      toast.error("End date is not set");
      return;
    }

    if (!validateForm()) {
      toast.error("Please fill in the details");
      return;
    }

    if (!startTime) {
      toast.error("Start time is not set");
      return;
    }

    if (!endTime) {
      toast.error("End time is not set");
      return;
    }

    if (!selectedBonzahType || selectedBonzahType.length === 0) {
      toast.error("Please select a trip insurance option");
      return;
    }

    const selectedInsuranceProductLater = bonzahProducts?.insurance_options?.find(
      (p: any) => JSON.stringify(p.value) === JSON.stringify(selectedBonzahType),
    );
    const requiresProofOfInsuranceLater =
      selectedInsuranceProductLater &&
      selectedInsuranceProductLater.upload_before_payment === true;
    if (requiresProofOfInsuranceLater && proofOfInsuranceFiles.length === 0) {
      toast.error("Please upload your Proof of Insurance document");
      return;
    }

    setLoadingLater(true);

    const selectedAddons = Array.from(selectedBonzahProducts)?.filter((item) =>
      bonzahProducts?.addons.some((addon: any) => addon.value[0] === item),
    );

    const addonsValues: string[] = selectedAddons
      .map((item) => {
        const addon = bonzahProducts?.addons?.find(
          (addon: any) => addon.value[0] === item,
        );
        return addon ? addon.value : [];
      })
      .flat();

    const customerPayload = {
      first_name: firstName,
      last_name: lastName,
      email,
      phone_no: phone,
      company: globalJson.company_id,
    };

    try {
      const response = await AddCustomer(customerPayload);
      if (response.error) {
        toast.error(response.error);
        return;
      }
      if (!startDate || !endDate) {
        toast.error("No start date or end date");
        return;
      }

      if (response.data) {
        localStorage.setItem("access_token", response.data.access_token);
        localStorage.setItem("refresh_token", response.data.refresh_token);
        localStorage.setItem("user", JSON.stringify(response.data));

        const customerId = response.data.id;

        let payload: any = {
          customer: customerId,
          fleet: selectedCar?.id,
          pick_up_time: formatDateTime(startDate, startTime),
          drop_off_time: formatDateTime(endDate, endTime),
          pick_up_location: pickupLocation?.id,
          drop_off_location:
            sameDropoffLocation === false
              ? dropOffLocation?.id
              : pickupLocation?.id,
          custom_pick_up_address: searchedPickupLoction,
          custom_drop_off_address:
            sameDropoffLocation === false
              ? searchedDropoffLocation
              : searchedPickupLoction,
          same_drop_off: sameDropoffLocation,
          extras: Array.from(selectedExtras),
          bonzah_insurance_options: [...selectedBonzahType, ...addonsValues],
          pay_later: true,
        };

        if (
          ourCompany?.allow_long_term_rentals &&
          long_term_rental_nature !== "daily"
        ) {
          payload = {
            ...payload,
            is_long_term_rental: is_long_term_rental,
            long_term_rental_nature: long_term_rental_nature,
            long_term_rental_duration: long_term_rental_duration,
          };
        }

        let finalBookingLaterPayload: any = payload;
        const bookingdetail = await Booking(finalBookingLaterPayload);
        if (bookingdetail.error) {
          toast.error(bookingdetail.error);
          setLoadingLater(false);
          return;
        }
        if (requiresProofOfInsuranceLater && proofOfInsuranceFiles.length > 0 && bookingdetail?.id) {
          for (const { file } of proofOfInsuranceFiles) {
            await uploadInsuranceDocuments(String(bookingdetail.id), file);
          }
        }
        setBookingdetails(bookingdetail);
        // Fetch rental agreement then navigate to policies page
        const encodedData = encodeBase64(bookingdetail?.customer?.email ?? "");
        const path = `${bookingdetail.id}b6cr4${ourCompany?.company?.id}b6cr4${encodedData}`;
        let pdfBase = "";
        if (process.env.REACT_APP_ENV === "dev") pdfBase = "https://dev.1now.app/pdf?agreement=";
        else if (process.env.REACT_APP_ENV === "stage") pdfBase = "https://stage.1now.app/pdf?agreement=";
        else pdfBase = "https://1now.app/pdf?agreement=";
        const pdfUrl = `${pdfBase}${path}`;
        let agreementContent: any = null;
        let privacyPolicyContent: any = [];
        let cancellationPolicyContent: any = [];
        try {
          const agResponse = await getRentalAgreementContent(path);
          if (agResponse?.data) {
            agreementContent = agResponse.data;
            privacyPolicyContent = agResponse.data.content.privacy_policy;
            cancellationPolicyContent = agResponse.data.content.cancellation_policy;
          }
        } catch (e) {
          console.error("Error fetching rental agreement:", e);
        }
        setProofOfInsuranceFiles([]);
        navigate("/pay-later-policies", {
          state: {
            bookingIdentifier: bookingdetail?.unique_identifier,
            pdfUrl,
            agreementContent,
            privacyPolicyContent,
            cancellationPolicyContent,
          },
        });
      }
    } catch (err: any) {
      toast.error(err.message || "Failed to complete booking");
      setLoadingLater(false);
    } finally {
      setLoadingLater(false);
    }
  };

  const callOurLocationAPI = async () => {
    if (selectedCar) {
      try {
        const data = await getLocationData(selectedCar?.id);
        if (Array.isArray(data)) {
          setOurLocation(data as LocationListingModal[]);
        } else {
          throw new Error("Unable to fetch location data");
        }
      } catch (error: any) {
        toast.error(error.message || "Failed to fetch locations");
        console.error("Location API error:", error);
      } finally {
        setLoading(false);
      }
    }
  };

  const handleOpenModalImageGallery = (index: number) => {
    if (selectedCar?.fleet_photos?.length === 0) {
      toast("No Images available for this fleet", {
        style: {
          background: "#fff3cd",
          color: "#856404",
        },
      });
    } else {
      setCurrentIndex(index);
      setIsOpenModal(true);
    }
  };



  const renderUserSection = () => {
    return (
      <div className="border-secondary-100 flex flex-col sm:rounded-md border-b sm:border-t sm:border-l sm:border-r sm:space-y-8 pb-10 px-0 sm:p-4 xl:p-8 !space-y-6">
        {" "}
        <h2 className="text-xl text-text-color font-bold">Trip Details</h2>
        <form className="flex flex-col border-secondary-100 rounded-md ">
          <div className={`${isDdropOffdifferent ? " " : "w-full my-2"}`}>
            <LocationBranchInput
              ourLocation={ourLocation}
              placeHolder="Pick Up Location"
              className="w-full rounded-md border border-secondary-100 text-text-color placeholder:text-text-color"
              sameDropOffLocation={dropoffLocationType === false}
              searchBar={false}
            />
          </div>
          {isDropOffVisible && (
            <div className="my-2">
              <DropOffBranchLocationInput
                ourLocation={ourLocation}
                placeHolder="Dropoff Location"
                className="w-full border-secondary-100 rounded-md border"
                divHideVerticalLineClass="-inset-x-0.5"
                searchBar={false}
              />

              <p
                className="text-xs text-text-color cursor-pointer mt-2 font-semibold"
                onClick={handlePickupLocationClick}
              >
                - Same Dropoff Location
              </p>
            </div>
          )}
          {/* If drop-off location is not visible, show the toggle text */}
          {!isDropOffVisible &&
            ourLocation.some(
              (loc) =>
                loc.location_type === "drop_off" || loc.location_type === "both"
            ) && (
            <p
              className="text-xs text-text-color cursor-pointer mb-2 font-semibold"
              onClick={handleDropOffLocationClick}
            >
              + Different Dropoff Location
            </p>
          )}

          {pickupLocation && (
            <>
              {ourCompany?.allow_long_term_rentals ? (
                <DateRangeSelection
                  isMiddle={true}
                  className="w-full rounded-md my-2 border border-secondary-100"
                  selectedCar={selectedCar}
                  onSaveDates={fetchInvoice}
                />
              ) : (
                <RentalCarDatesRangeInput
                  isMiddle={true}
                  className="w-full rounded-md my-2 border border-secondary-100"
                  selectedCar={selectedCar}
                  searchBar={false}
                  minDays={selectedCar?.min_trip_duration}
                  maxDays={selectedCar?.max_trip_duration}
                />
              )}
            </>
          )}

          {startDate && endDate && (
            <RentalCarTimesRangeInput
              dropOffLocationType={dropoffLocationType}
              className="w-full rounded-md border my-2 border-secondary-100"
              searchBar={false}
            />
          )}
        </form>
        <h2 className="text-xl text-text-color  font-bold">Renter Details</h2>
        <div className="grid grid-cols-2 gap-6">
          <div>
            <div className="border border-secondary-100 p-2 rounded-md">
              <span className="my-2 text-sm text-text-color">First Name</span>
              <Input
                placeholder=""
                value={firstName}
                className="border-none !p-0 focus:outline-none focus:ring-0"
                onChange={(e: ChangeEvent<HTMLInputElement>) => {
                  setFirstName(e.target.value);
                  if (e.target.value) clearError("firstName");
                }}
              />
            </div>
            {errors.firstName && (
              <span className="text-red-500 text-xs font-semibold">
                {errors.firstName}
              </span>
            )}
          </div>
          <div>
            <div className="border border-secondary-100 p-2 rounded-md">
              <span className="my-2 text-sm text-text-color">Last Name</span>
              <Input
                placeholder=""
                value={lastName}
                className="border-none !p-0 focus:outline-none focus:ring-0"
                onChange={(e: ChangeEvent<HTMLInputElement>) => {
                  setLastName(e.target.value);
                  if (e.target.value) clearError("lastName");
                }}
              />
            </div>
            {errors.lastName && (
              <span className="text-red-500 text-xs font-semibold">
                {errors.lastName}
              </span>
            )}
          </div>
          <div>
            <div className="border border-secondary-100 p-2 rounded-md">
              <span className="my-2 text-sm text-text-color">Email</span>
              <Input
                placeholder=""
                type="email"
                className="border-none !p-0 focus:outline-none focus:ring-0"
                value={email}
                onChange={(e: ChangeEvent<HTMLInputElement>) => {
                  setEmail(e.target.value);
                  if (
                    /^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/.test(
                      e.target.value,
                    )
                  ) {
                    clearError("email");
                  }
                }}
              />
            </div>
            {errors.email && (
              <span className="text-red-500 text-xs font-semibold">
                {errors.email}
              </span>
            )}
          </div>
          <div>
            <div className="border border-secondary-100 p-2 rounded-md">
              <span className="my-2 text-sm text-text-color">Phone</span>
              <PhoneInput
                country={"us"}
                value={phone}
                onChange={(phone) => {
                  setPhone(phone);
                  if (phone.length >= 10) clearError("phone");
                }}
                inputProps={{
                  name: "phone",
                  required: true,
                  autoFocus: false,
                }}
                inputStyle={{
                  border: "none",
                  width: "100%",
                  minHeight: "44px",
                  boxShadow: "none",
                  background: "transparent",
                }}
                buttonStyle={{
                  background: "transparent",
                  border: "none",
                }}
              />
            </div>
            {errors.phone && (
              <span className="text-red-500 text-xs font-semibold ">
                {errors.phone}
              </span>
            )}
          </div>
        </div>
      </div>
    );
  };

  const handleExtraChange = (extraId: any, checked: any) => {
    setSelectedExtras((prevSelectedExtras) => {
      const updatedExtras = new Set(prevSelectedExtras);
      if (checked) {
        updatedExtras.add(extraId);
      } else {
        updatedExtras.delete(extraId);
      }
      return updatedExtras;
    });
  };

  const renderSidebarPrice = () => {
    // if (!pickupLocation) return null;
    if (
      ourCompany?.allow_long_term_rentals &&
      startDate &&
      endDate &&
      long_term_rental_nature !== "daily" &&
      long_term_rental_duration > 1
    ) {
      return (
        <LongTermRentalUI
          handleBooking={handleBooking}
          loading={loading}
          loadingLater={loadingLater}
          handleBookingLater={handleBookingLater}
        />
      );
    }
    return (
      <div className="listingSectionSidebar__wrap shadow-xl mt-4 lg:mt-0 p-6 lg:p-12 lg:max-w-xl  ">
        {pickupLocation && (
          <>
            {" "}
            <h2 className=" text-2xl sm:text-3xl lg:text-3xl font-bold text-text-color ">
              Booking Details
            </h2>
            <div className="mt-8 flex">
              <div className="flex-shrink-0 flex flex-col items-center py-2">
                <span className="block w-6 h-6 rounded-full border border-secondary-100"></span>
                <span className="block flex-grow border-l border-secondary-100 border-dashed my-1"></span>
                <span className="block w-6 h-6 rounded-full border border-secondary-100"></span>
              </div>
              <div className="ml-4 space-y-14 text-sm">
                <div className="flex flex-col space-y-2">
                  <span className=" text-text-color ">Pick up</span>
                  <span className="text-text-color font-semibold">
                    {" "}
                    {pickupLocation?.name}
                  </span>
                  {startDate && (
                    <span className=" font-semibold text-text-color !mt-0">
                      {moment(startDate).format("ddd, D MMM YYYY")}{" "}
                      {ourCompany?.default_time_format === "24_hour"
                        ? moment(startDate).format("H:mm")
                        : moment(startDate).format("h:mm A")}
                    </span>
                  )}
                </div>
                <div className="flex flex-col space-y-2">
                  <span className=" text-text-color ">Drop Off</span>
                  <span className="text-text-color font-semibold">
                    {dropoffLocationType === false && dropOffLocation?.name
                      ? dropOffLocation?.name
                      : pickupLocation?.name}
                  </span>
                  {endDate && (
                    <span className=" font-semibold text-text-color !mt-0">
                      {moment(endDate).format("ddd, D MMM YYYY")}{" "}
                      {ourCompany?.default_time_format === "24_hour"
                        ? moment(endDate).format("H:mm")
                        : moment(endDate).format("h:mm A")}
                    </span>
                  )}
                </div>
              </div>
            </div>
          </>
        )}

        <div className="w-full max-w-lg  mx-auto ">
          <h2 className="text-xl font-medium text-text-color">Rental Bill</h2>
          <p className="mt-2 text-sm text-text-color">
            Prices may change depending on the length of the rental and the
            price of your rental car.
          </p>

          {pickupLocation !== null && invoice?.car_total !== undefined && (
            <Invoice invoice={invoice} carName={selectedCar?.name} />
          )}
        </div>

        <ButtonPrimary
          className="block rounded-3xl"
          disabled={loading}
          onClick={() => {
            handleBooking();
          }}
        >
          {loading ? (
            <div className="flex justify-center items-center col-span-full">
              <div className="spinner-border animate-spin inline-block w-6 h-6 border-4 rounded-full border-t-transparent border-secondary-100"></div>
            </div>
          ) : (
            "Pay & Book"
          )}
        </ButtonPrimary>
        {selectedCar?.pay_later && (
          <ButtonPrimary
            className="block rounded-lg mt-4"
            disabled={loadingLater}
            onClick={() => {
              handleBookingLater();
            }}
          >
            {loadingLater ? (
              <div className="flex justify-center items-center col-span-full">
                <div className="spinner-border animate-spin inline-block w-6 h-6 border-4 rounded-full border-t-transparent border-gray-300"></div>
              </div>
            ) : (
              "Pay Later"
            )}
          </ButtonPrimary>
        )}
      </div>
    );
  };

  const renderDescriptionWithLink = (description: string) => {
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    const parts = description.split(urlRegex);

    return parts.map((part, index) => {
      if (urlRegex.test(part)) {
        return (
          <a
            key={index}
            href={part}
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-500 hover:underline"
          >
            {part}
          </a>
        );
      }
      return <span key={index}>{part}</span>;
    });
  };

  useEffect(() => {
    if (selectedCar?.extras) {
      const requiredExtras = selectedCar.extras
        .filter((extra: any) => extra.is_required)
        .map((extra: any) => extra.id);
      setSelectedExtras((prev) => {
        const updated = new Set(prev);
        requiredExtras.forEach((id) => updated.add(id));
        return updated;
      });
    }
  }, [selectedCar]);

  const renderExtrasSection = () => {
    return (
      <div className="listingSection__wrap !mb-10">
        <h2 className="text-2xl font-bold text-text-color ">Trip Extras</h2>
        {!bonzahProductsLoading &&
          (!isMoreThan30Days || (is_long_term_rental && long_term_rental_nature !== "daily")) &&
          bonzahProducts?.addons?.map((addon: any) => (
            <div
              key={addon.title}
              className="flex flex-col justify-between items-start border border-secondary-100 rounded-md p-4  max-w-full"
            >
              <div className="flex items-start">
                <Checkbox
                  checked={selectedBonzahAddOns.has(addon.value[0])}
                  onChange={() => toggleAddonSelection(addon.value[0])}
                  className="group size-7 rounded-md p-1 ring-1 ring-primary-200 data-[checked]:bg-primary-200 data-[checked]:bg-opacity-20 ring-inset  mr-4"
                >
                  <CheckIcon
                    className={`size-5 stroke-primary-200 ${selectedBonzahAddOns.has(addon.value[0])
                      ? "visible"
                      : "invisible"
                      }`}
                  />
                </Checkbox>

                <div>
                  <div className="flex items-center mb-2">
                    <h2 className="text-lg md:text-xl font-bold text-text-color ">
                      {addon.title}
                    </h2>
                    <button
                      className="ml-2 text-text-color"
                      onClick={() => window.open(addon.pdf, "_blank")}
                    >
                      <svg
                        width="25"
                        height="24"
                        viewBox="0 0 25 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M12.7998 22.75C6.8698 22.75 2.0498 17.93 2.0498 12C2.0498 6.07 6.8698 1.25 12.7998 1.25C18.7298 1.25 23.5498 6.07 23.5498 12C23.5498 17.93 18.7298 22.75 12.7998 22.75ZM12.7998 2.75C7.6998 2.75 3.5498 6.9 3.5498 12C3.5498 17.1 7.6998 21.25 12.7998 21.25C17.8998 21.25 22.0498 17.1 22.0498 12C22.0498 6.9 17.8998 2.75 12.7998 2.75Z"
                          fill="#9AA3AD"
                        />
                        <path
                          d="M12.7998 13.75C12.3898 13.75 12.0498 13.41 12.0498 13V8C12.0498 7.59 12.3898 7.25 12.7998 7.25C13.2098 7.25 13.5498 7.59 13.5498 8V13C13.5498 13.41 13.2098 13.75 12.7998 13.75Z"
                          fill="#9AA3AD"
                        />
                        <path
                          d="M12.7998 16.9999C12.6698 16.9999 12.5398 16.9699 12.4198 16.9199C12.2998 16.8699 12.1898 16.7999 12.0898 16.7099C11.9998 16.6099 11.9298 16.5099 11.8798 16.3799C11.8298 16.2599 11.7998 16.1299 11.7998 15.9999C11.7998 15.8699 11.8298 15.7399 11.8798 15.6199C11.9298 15.4999 11.9998 15.3899 12.0898 15.2899C12.1898 15.1999 12.2998 15.1299 12.4198 15.0799C12.6598 14.9799 12.9398 14.9799 13.1798 15.0799C13.2998 15.1299 13.4098 15.1999 13.5098 15.2899C13.5998 15.3899 13.6698 15.4999 13.7198 15.6199C13.7698 15.7399 13.7998 15.8699 13.7998 15.9999C13.7998 16.1299 13.7698 16.2599 13.7198 16.3799C13.6698 16.5099 13.5998 16.6099 13.5098 16.7099C13.4098 16.7999 13.2998 16.8699 13.1798 16.9199C13.0598 16.9699 12.9298 16.9999 12.7998 16.9999Z"
                          fill="#9AA3AD"
                        />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
              <div className="mt-4 md:mt-0 w-full">
                <p className="lg:text-2xl text-lg font-bold text-text-color flex justify-end items-center">
                  ${formatPrice(addon?.price)}
                  <span className="text-text-color lg:text-lg">/day</span>
                </p>
              </div>
            </div>
          ))}
        {selectedCar?.extras.map((extra) => (
          <div
            key={extra.id}
            className="w-full rounded-md border border-secondary-100 flex flex-wrap justify-between items-center p-5"
          >
            <div className="flex justify-start flex-1 min-w-0">
              <Checkbox
                checked={selectedExtras?.has(extra.id)}
                onChange={(checked) => {
                  if (!extra.is_required) {
                    handleExtraChange(extra.id, checked);
                  }
                }}
                className="group size-7 rounded-md  p-1 ring-1 ring-primary-200 ring-inset data-[checked]:bg-primary-200 data-[checked]:bg-opacity-20  mr-4"
                disabled={extra.is_required}
              >
                <CheckIcon
                  className={`size-5 stroke-primary-200 ${selectedExtras.has(extra.id) ? "visible" : "invisible"
                    }`}
                />
              </Checkbox>
              <div className="min-w-0">
                <div className="text-text-color lg:text-lg sm:text-l font-bold flex space-x-2 flex-wrap break-words">
                  <span className="truncate block max-w-xs">{extra.name}</span>
                </div>
                <div className="text-text-color lg:text-lg sm:text-md font-medium ">
                  {renderDescriptionWithLink(extra.description)}
                </div>
              </div>
            </div>

            <div className="mt-4 md:mt-0 flex-shrink-0 flex flex-col items-end">
              <div className="mb-2 flex space-x-2">
                {extra.is_required && <Badge color="blue" name="Required" />}
                {extra.is_recommended === true && (
                  <Badge color="blue" name="Recommended" />
                )}
              </div>
              <p className="lg:text-2xl text-lg font-bold text-text-color flex justify-end items-center whitespace-nowrap">
                ${formatPrice(extra?.amount)}
                <span className="text-text-color lg:text-lg">
                  {" "}
                  /{extra?.nature === "per_day" ? "day" : "trip"}
                </span>
              </p>
            </div>
          </div>
        ))}
      </div>
    );
  };

  const renderBonzahSection = () => {
    return (
      <div className="listingSection__wrap">
        <h2 className="text-2xl text-text-color  font-bold">Trip Insurance</h2>
        {bonzahProducts?.insurance_options
          ?.filter(
            (product: any) =>
              !(
                isMoreThan30Days &&
                product.insurance_by_bonzah === true &&
                (!is_long_term_rental || long_term_rental_nature === "daily")
              ),
          )
          .map((product: any, index: any) => (
            <div
              key={product.title}
              className="flex flex-col justify-between items-start border border-secondary-100 rounded-md p-4  max-w-full"
              style={{ wordBreak: "break-word" }}
            >
              <div className="flex items-start w-full">
                <Checkbox
                  checked={
                    JSON.stringify(selectedBonzahType) ===
                    JSON.stringify(product?.value)
                  }
                  onChange={() =>
                    handleBonzahProductSelection(
                      product.title.toLowerCase(),
                      product?.value,
                      product.canopy,
                    )
                  }
                  className="group size-7 rounded-md p-1 ring-1 ring-primary-200 ring-inset data-[checked]:bg-primary-200 data-[checked]:bg-opacity-20  mr-4"
                >
                  <CheckIcon
                    className={`size-5 stroke-primary-200 ${JSON.stringify(selectedBonzahType) ===
                      JSON.stringify(product?.value)
                      ? "visible"
                      : "invisible"
                      }`}
                  />
                </Checkbox>

                <div className="flex-1 min-w-0">
                  <div className="flex items-center mb-2">
                    <h2 className="text-lg md:text-xl font-bold text-text-color">
                      {product.title}
                    </h2>
                    {product?.pdf !== "" && (
                      <button
                        className="ml-2 text-text-color"
                        onClick={() => window.open(product.pdf, "_blank")}
                        type="button"
                        tabIndex={-1}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          fill="none"
                          viewBox="0 0 20 20"
                        >
                          <path
                            fill="#1B2430"
                            d="M9.997 18.958c-4.941 0-8.958-4.016-8.958-8.958s4.017-8.958 8.958-8.958c4.942 0 8.959 4.016 8.959 8.958s-4.017 8.958-8.959 8.958Zm0-16.666C5.747 2.292 2.29 5.75 2.29 10s3.458 7.708 7.708 7.708S17.706 14.25 17.706 10s-3.459-7.708-7.709-7.708Z"
                          />
                          <path
                            fill="#1B2430"
                            d="M10 11.458a.63.63 0 0 1-.625-.625V6.667A.63.63 0 0 1 10 6.042a.63.63 0 0 1 .625.625v4.166a.63.63 0 0 1-.625.625Zm-.003 2.709a.829.829 0 0 1-.316-.067.963.963 0 0 1-.275-.175.86.86 0 0 1-.175-.275.83.83 0 0 1-.067-.317.83.83 0 0 1 .067-.316c.041-.1.1-.192.175-.275a.96.96 0 0 1 .275-.175.833.833 0 0 1 .633 0c.1.041.192.1.275.175a.963.963 0 0 1 .175.275.83.83 0 0 1 .067.316.83.83 0 0 1-.067.317.86.86 0 0 1-.175.275.964.964 0 0 1-.275.175.83.83 0 0 1-.317.067Z"
                          />
                        </svg>
                      </button>
                    )}
                  </div>

                  {product?.options &&
                    Object.entries(product.options).map(([key, values]) => (
                      <div key={key} className="mt-2">
                        {!product.canopy && product.insurance_by_bonzah && (
                          <h3 className="font-semibold text-text-color uppercase truncate">
                            {key}
                          </h3>
                        )}

                        <p className="lg:text-lg text-md text-text-color break-words">
                          {(Array.isArray(values) ? values : [values]).map(
                            (detail, index) => {
                              // If detail is HTML from Quill editor, render as HTML but make links clickable
                              if (
                                typeof detail === "string" &&
                                detail.trim().startsWith("<")
                              ) {
                                // Replace URLs in HTML with anchor tags if not already wrapped
                                const urlRegex = /(https?:\/\/[^\s<>"']+)/g;
                                let html = detail.replace(urlRegex, (url) => {
                                  // If already inside an anchor tag, skip
                                  if (detail.includes(`<a href="${url}`))
                                    return url;
                                  return `<a href="${url}" target="_blank" rel="noopener noreferrer" class="text-blue-500 hover:underline">${url}</a>`;
                                });
                                return (
                                  <span
                                    key={index}
                                    className={
                                      product.canopy
                                        ? "text-red-500 font-semibold"
                                        : ""
                                    }
                                    style={{ wordBreak: "break-word" }}
                                    dangerouslySetInnerHTML={{ __html: html }}
                                  />
                                );
                              }
                              // If detail contains a URL, make it clickable
                              const urlRegex = /(https?:\/\/[^\s]+)/g;
                              if (
                                typeof detail === "string" &&
                                urlRegex.test(detail)
                              ) {
                                const parts = detail.split(urlRegex);
                                return (
                                  <span
                                    key={index}
                                    className={
                                      product.canopy
                                        ? "text-red-500 font-semibold"
                                        : ""
                                    }
                                    style={{ wordBreak: "break-word" }}
                                  >
                                    {parts.map((part, i) =>
                                      urlRegex.test(part) ? (
                                        <a
                                          key={i}
                                          href={part}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                          className="text-blue-500 hover:underline"
                                          style={{ wordBreak: "break-word" }}
                                        >
                                          {part}
                                        </a>
                                      ) : (
                                        <React.Fragment key={i}>
                                          {part}
                                        </React.Fragment>
                                      ),
                                    )}
                                    <br />
                                  </span>
                                );
                              }
                              // Otherwise, render as plain text
                              return (
                                <span
                                  key={index}
                                  className={
                                    product.canopy
                                      ? "text-red-500 font-semibold"
                                      : ""
                                  }
                                  style={{ wordBreak: "break-word" }}
                                >
                                  {detail}
                                  <br />
                                </span>
                              );
                            },
                          )}
                        </p>
                      </div>
                    ))}
                </div>
              </div>

              <div className="mt-4 md:mt-0 w-full flex justify-end items-center">
                <p className="lg:text-2xl text-lg font-bold text-text-color">
                  ${formatPrice(product.price)}
                  <span className="text-text-color lg:text-lg">
                    /
                    {product.nature === "per_trip"
                      ? "trip"
                      : product.nature === "per_day"
                        ? "day"
                        : "24 hours"}
                  </span>
                </p>
              </div>
              {product.upload_before_payment === true &&
                JSON.stringify(selectedBonzahType) ===
                JSON.stringify(product?.value) && (
                  <div className="mt-4 w-full">
                    {proofOfInsuranceFiles.length > 0 && (
                      <div className="mb-3 flex flex-col gap-2">
                        {proofOfInsuranceFiles.map(({ file, url }, index) => (
                          <div key={index} className="w-full border border-secondary-100 rounded-md p-4 flex items-center gap-4">
                            {file.type.startsWith("image/") ? (
                              <img
                                src={url}
                                alt="Proof of Insurance preview"
                                className="h-24 w-40 object-cover rounded-md flex-shrink-0"
                              />
                            ) : file.type.startsWith("video/") ? (
                              <video
                                src={url}
                                className="h-24 w-40 object-cover rounded-md flex-shrink-0 bg-black"
                                controls
                                preload="metadata"
                                playsInline
                              />
                            ) : (
                              <div className="h-24 w-40 flex items-center justify-center bg-gray-100 rounded-md flex-shrink-0">
                                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 24 24">
                                  <path fill="#9AA3AD" d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6zm-1 1.5L18.5 9H13V3.5zM6 20V4h5v7h7v9H6z" />
                                </svg>
                              </div>
                            )}
                            <div className="flex-1 min-w-0">
                              <p className="text-sm font-medium text-text-color truncate">{file.name}</p>
                              <p className="text-xs text-gray-400 mt-1">{file.size >= 1024 * 1024 ? `${(file.size / (1024 * 1024)).toFixed(2)} MB` : `${(file.size / 1024).toFixed(1)} KB`}</p>
                              <div className="flex gap-3 mt-2">
                                <a
                                  href={url}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="text-xs text-primary-200 font-semibold hover:underline"
                                >
                                  {file.type.startsWith("image/") ? "Preview" : file.type.startsWith("video/") ? "Play" : "Open"}
                                </a>
                                <button
                                  type="button"
                                  onClick={() => {
                                    URL.revokeObjectURL(url);
                                    setProofOfInsuranceFiles(prev => prev.filter((_, i) => i !== index));
                                    if (fileInputRef.current) fileInputRef.current.value = "";
                                  }}
                                  className="text-xs text-red-500 font-semibold hover:underline"
                                >
                                  Delete
                                </button>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                    <input
                      ref={fileInputRef}
                      type="file"
                      style={{ display: "none" }}
                      accept="image/*,video/*,application/pdf"
                      multiple
                      onChange={(e) => {
                        const files = e.target.files ? Array.from(e.target.files) : [];
                        if (files.length > 0) {
                          setProofOfInsuranceFiles(prev => [
                            ...prev,
                            ...files.map(f => ({ file: f, url: URL.createObjectURL(f) }))
                          ]);
                        }
                        e.target.value = "";
                      }}
                    />
                    <div
                      role="button"
                      tabIndex={0}
                      onClick={() => fileInputRef.current?.click()}
                      onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") fileInputRef.current?.click(); }}
                      className="flex flex-col items-center justify-center w-full border-2 border-dashed border-secondary-100 rounded-md p-6 cursor-pointer hover:border-primary-200 transition-colors"
                    >
                      <svg
                        width="44"
                        height="44"
                        viewBox="0 0 44 44"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect x="2" y="2" width="40" height="40" rx="8" stroke="#9AA3AD" strokeWidth="2" />
                        <path d="M22 30V14M22 14L16 20M22 14L28 20" stroke="#9AA3AD" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                      <span className="mt-2 text-sm text-text-color">Proof Of Insurance</span>
                    </div>
                  </div>
                )}
            </div>
          ))}
      </div>
    );
  };

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const carIdParam = searchParams.get("selectedCarId");

    if (!carIdParam) {
      navigate("/");
    }
  }, []);

  return (
    <>
      <div className={`ListingCarDetailPage container`}>
        <div className="flex justify-between items-center my-4">
          <BackRouteButton iconVariant="square" />
          <span className="text-xl font-semibold truncate block text-text-color">
            {selectedCar?.name}
          </span>
        </div>
        <header className="rounded-md sm:rounded-xl">
          <div className="relative grid grid-cols-1 md:grid-cols-4  gap-1 sm:gap-2 min-h-96 ">
            <div
              className="col-span-2 row-span-2 relative rounded-md sm:rounded-xl overflow-hidden cursor-pointer"
              onClick={() => {
                handleOpenModalImageGallery(0);
                setCurrentIndex(0);
              }}
            >
              <img
                src={
                  (selectedCar?.fleet_photos?.length ?? 0) > 0
                    ? selectedCar?.fleet_photos[0].photo_url.includes("http")
                      ? selectedCar?.fleet_photos[0].photo_url
                      : `https://fleet-management-images-upload-be.s3.amazonaws.com/${selectedCar?.fleet_photos[0].photo_url}`
                    : "https://tenant.fleetwire.io/images/vehicle-placeholder.jpg"
                }
                alt="0"
                className="absolute inset-0 object-cover rounded-md sm:rounded-md w-full h-full"
                sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 50vw"
              />
              <div className="absolute inset-0 bg-neutral-900 bg-opacity-20 opacity-0 hover:opacity-100 transition-opacity"></div>
            </div>

            {/*  */}
            <div
              className="col-span-1 row-span-2 relative rounded-md sm:rounded-xl overflow-hidden cursor-pointer"
              onClick={() => {
                handleOpenModalImageGallery(1);
                setCurrentIndex(1);
              }}
            >
              <img
                className="absolute inset-0 object-cover rounded-md sm:rounded-xl w-full h-full"
                src={
                  (selectedCar?.fleet_photos?.length ?? 0) > 1
                    ? selectedCar?.fleet_photos[1].photo_url.includes("http")
                      ? selectedCar?.fleet_photos[1].photo_url
                      : `https://fleet-management-images-upload-be.s3.amazonaws.com/${selectedCar?.fleet_photos[1].photo_url}`
                    : "https://tenant.fleetwire.io/images/vehicle-placeholder.jpg"
                }
                alt="1"
                sizes="400px"
              />
              <div className="absolute inset-0 bg-neutral-900 bg-opacity-20 opacity-0 hover:opacity-100 transition-opacity"></div>
            </div>

            {/*  */}
            {selectedCar?.fleet_photos
              .filter((_: any, i: any) => i >= 2 && i < 4)
              .map((item: any, index: any) => (
                <div
                  key={index}
                  className={`relative rounded-md sm:rounded-xl overflow-hidden ${index >= 2 ? "block" : ""
                    }`}
                >
                  <div className="aspect-w-4 aspect-h-3">
                    <img
                      className="absolute inset-0 object-cover w-full h-full rounded-md sm:rounded-xl "
                      src={
                        item.photo_url.includes("http")
                          ? item.photo_url
                          : `https://fleet-management-images-upload-be.s3.amazonaws.com/${item.photo_url}`
                      }
                      alt="photos"
                      sizes="400px"
                    />
                  </div>
                  <div
                    className="absolute inset-0 bg-neutral-900 bg-opacity-20 opacity-0 hover:opacity-100 transition-opacity cursor-pointer"
                    onClick={() => {
                      handleOpenModalImageGallery(2);
                      setCurrentIndex(2);
                    }}
                  />
                </div>
              ))}

            {((selectedCar?.fleet_photos?.length ?? 0) > 1) && (
              <div
                className="absolute flex md:items-center md:justify-center left-3 bottom-3 px-4 py-2 rounded-xl bg-neutral-100 text-neutral-500 cursor-pointer hover:bg-neutral-200 z-10"
                onClick={() => setIsGridOpen(true)}
              >
                <Squares2X2Icon className="h-5 w-5" />
                <span className="ml-2 text-neutral-800 text-sm font-medium">
                  Show all photos
                </span>
              </div>
            )}
          </div>
        </header>

        {isGridOpen && (
          <div className="fixed inset-0 z-50 bg-black bg-opacity-60 flex items-center justify-center p-4">
            <div className="relative w-full max-w-5xl bg-white rounded-lg overflow-auto p-4">
              <button
                className="absolute top-1 right-3 text-lg text-text-color bg-white rounded-full w-10 h-10 flex items-center justify-center z-10"
                onClick={closeGridModal}
                aria-label="Close gallery"
                type="button"
              >
                ✖
              </button>
              <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 pt-8">
                {(selectedCar?.fleet_photos ?? []).map(
                  (item: any, idx: number) => (
                    <button
                      key={idx}
                      onClick={() => {
                        setCurrentIndex(idx);
                        setIsOpenModal(true);
                        setIsGridOpen(false);
                      }}
                      className="w-full h-32 sm:h-40 md:h-48 overflow-hidden rounded-md focus:outline-none focus:ring-2 focus:ring-primary-100 transition-transform hover:scale-105"
                      type="button"
                    >
                      <img
                        src={
                          item.photo_url?.includes("http")
                            ? item.photo_url
                            : `https://fleet-management-images-upload-be.s3.amazonaws.com/${item.photo_url}`
                        }
                        alt={`photo-${idx}`}
                        className="w-full h-full object-cover"
                      />
                    </button>
                  ),
                )}
                {(selectedCar?.fleet_photos?.length ?? 0) === 0 && (
                  <div className="col-span-full text-center p-8 text-text-color">
                    No images available
                  </div>
                )}
              </div>
            </div>
          </div>
        )}

        {isOpenModal && (
          <div className="fixed h-full top-0 left-0 w-full bg-bg-color  flex items-center justify-center z-50">
            <button
              className="absolute top-5 right-5 text-text-color text-xl"
              onClick={closeModal}
            >
              ✖
            </button>

            <div className="w-4/5 ">
              <Slide
                defaultIndex={currentIndex}
                indicators={(selectedCar?.fleet_photos?.length ?? 0) > 1}
                arrows={(selectedCar?.fleet_photos?.length ?? 0) > 1}
                autoplay={false}
                duration={2000}
                transitionDuration={300}
                onChange={(current, next) => {
                  setCurrentIndex(next);
                }}
                prevArrow={
                  <button
                    className={`absolute left-4 top-1/2 -translate-y-1/2 z-10 flex items-center justify-center w-10 h-10 rounded-full bg-transparent text-text-color ${(selectedCar?.fleet_photos?.length ?? 0) <= 1 ||
                      currentIndex === 0
                      ? "invisible"
                      : ""
                      }`}
                    type="button"
                    aria-label="Previous"
                  >
                    <span className="default-nav !text-text-color">❮</span>
                  </button>
                }
                nextArrow={
                  <button
                    className={`absolute right-4 top-1/2 -translate-y-1/2 z-10 flex items-center justify-center w-10 h-10 rounded-full bg-transparent text-text-color ${(selectedCar?.fleet_photos?.length ?? 0) <= 1 ||
                      currentIndex ===
                      (selectedCar?.fleet_photos?.length ?? 0) - 1
                      ? "invisible"
                      : ""
                      }`}
                    type="button"
                    aria-label="Next"
                  >
                    <span className="default-nav !text-text-color">❯</span>
                  </button>
                }
              >
                {((selectedCar?.fleet_photos?.length ?? 0) || 0) > 0 ? (
                  selectedCar?.fleet_photos?.map((item: any, index: number) => (
                    <div
                      className="flex justify-center items-center h-full"
                      key={index}
                    >
                      <img
                        className="w-full max-h-full object-contain rounded-lg"
                        src={
                          item.photo_url.includes("http")
                            ? item.photo_url
                            : `https://fleet-management-images-upload-be.s3.amazonaws.com/${item.photo_url}`
                        }
                        alt={`Slide ${index}`}
                      />
                    </div>
                  ))
                ) : (
                  <div className="flex justify-center items-center h-full">
                    <img
                      className="w-full max-h-full object-contain rounded-lg"
                      src="https://tenant.fleetwire.io/images/vehicle-placeholder.jpg"
                      alt="No images available"
                    />
                  </div>
                )}
              </Slide>
            </div>
          </div>
        )}

        <main className=" relative z-10 mt-11 flex flex-col lg:flex-row ">
          <div className="w-full lg:w-3/5 xl:w-2/3 space-y-8 lg:pr-10 lg:space-y-10">
            {/* {vehicleFeaturesSection()} */}
            <VehicleDetailsSection data={selectedCar} />
            {renderUserSection()}
            {bonzahProducts?.insurance_options?.length > 0 &&
              renderBonzahSection()}
            {(bonzahProducts?.addons?.length > 0 ||
              (selectedCar?.extras ?? []).length > 0) &&
              renderExtrasSection()}
          </div>

          <div className="block mb-6 lg:mb-0 flex-grow mt-0 lg:mt-0">
            <div className="block sticky top-28 space-y-4">
              {renderSidebarPrice()}
            </div>
          </div>
        </main>
      </div>
      <NcModal
        isOpenProp={isDialogOpen}
        onCloseModal={cancelNavigation}
        modalTitle={"Leave this page?"}
        contentExtraClass="max-w-md"
        renderContent={() => (
          <div>
            <p className="text-sm text-neutral-600 dark:text-neutral-300">
              Your entered information will be lost. Are you sure you want to go
              back?
            </p>
            <div className="mt-6 flex justify-end space-x-3">
              <button
                type="button"
                className="px-4 py-2 rounded-md border border-neutral-300 dark:border-neutral-700"
                onClick={cancelNavigation}
              >
                Stay
              </button>
              <button
                type="button"
                className="px-4 py-2 rounded-md bg-red-600 text-white flex items-center gap-2 disabled:opacity-70"
                onClick={confirmNavigation}
                disabled={isLeaving}
              >
                {isLeaving && (
                  <svg className="animate-spin h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z" />
                  </svg>
                )}
                {isLeaving ? "Leaving…" : "Leave"}
              </button>
            </div>
          </div>
        )}
      />
    </>
  );
}
